(() => {
 const copy=JSON.parse(document.getElementById('lf-cart-copy').textContent);
 const root=window.Shopify?.routes?.root||'/';
 const eu=new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE CH'.split(' '));
 let currentCart, pending;
 const money=(n,currency='EUR')=>new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency}).format(n/100);
 function country(fallback){try{return sessionStorage.getItem('lf-destination')||fallback;}catch{return fallback;}}
 function threshold(code){return code==='DE'?2900:eu.has(code)?4900:null;}
 async function refresh(){
  if(pending)return pending;
  pending=fetch(root+'cart.js').then(r=>{if(!r.ok)throw Error();return r.json();}).then(cart=>{currentCart=cart;document.querySelectorAll('lf-shipping-progress,lf-refill-offer').forEach(el=>el.render?.(cart));return cart;}).catch(()=>null).finally(()=>pending=null);
  return pending;
 }
 class Shipping extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const select=this.querySelector('[data-destination]');
   const code=country(this.dataset.country);
   if([...select.options].some(o=>o.value===code))select.value=code;
   this.addEventListener('change',event=>{event.stopPropagation();try{sessionStorage.setItem('lf-destination',select.value);}catch{}document.querySelectorAll('lf-shipping-progress').forEach(el=>{el.querySelector('select').value=select.value;el.render(currentCart);});document.querySelectorAll('lf-refill-offer').forEach(el=>el.render(currentCart));});
   refresh();
  }
  render(cart){
   if(!cart)return;
   const limit=threshold(this.querySelector('select').value), currency=cart.currency;
   const text=this.querySelector('.lf-shipping__copy'), track=this.querySelector('[role=progressbar]'), sub=this.querySelector('.lf-shipping__threshold');
   track.hidden=!limit||currency!=='EUR';sub.textContent='';
   if(currency!=='EUR'){text.textContent=copy.currency;return;}
   if(!limit){text.textContent=copy.other;return;}
   const remaining=Math.max(0,limit-cart.total_price), percentage=Math.min(100,Math.round(cart.total_price/limit*100));
   text.textContent=remaining?copy.remaining.replace('[amount]',money(remaining,currency)):copy.free;
   track.setAttribute('aria-valuenow',percentage);track.querySelector('span').style.width=percentage+'%';
   sub.textContent=copy.threshold.replace('[amount]',money(limit,currency));
  }
 }
 class Refill extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const select=this.querySelector('select');
   this.addEventListener('change',event=>{
    if(this.dataset.mode==='cart')event.stopPropagation();
    this.render(currentCart);
   });
   this.querySelector('.lf-refill__add')?.addEventListener('click',()=>this.add());
   this.render(currentCart);refresh();
  }
  render(cart){
   const option=this.querySelector('select').selectedOptions[0];
   if(!option)return;
   this.querySelector('[data-refill-price]').textContent=(this.dataset.mode==='product'?'+ ':'')+money(Number(option.dataset.price),window.Shopify?.currency?.active||'EUR');
   if(this.dataset.mode==='product')return;
   const benefit=this.querySelector('[data-refill-benefit]');
   const shipping=document.querySelector('lf-shipping-progress');
   const limit=threshold(shipping?.querySelector('select').value||'DE');
   benefit.hidden=!(cart&&cart.currency==='EUR'&&limit&&cart.total_price<limit&&cart.total_price+Number(option.dataset.price)>=limit);
   benefit.textContent=copy.refill_free;
   if(cart&&!this.selectedInitial){
    const hanger=cart.items.find(i=>[10201054282065,10201073615185,10201195938129].includes(i.product_id));
    const match=[...this.querySelector('select').options].find(o=>!o.disabled&&o.dataset.title===hanger?.variant_title);
    if(match)this.querySelector('select').value=match.value;
    this.selectedInitial=true;
   }
  }
  async add(){
   if(this.busy)return;this.busy=true;
   const button=this.querySelector('button'), error=this.querySelector('[role=alert]');
   button.disabled=true;button.textContent=copy.loading;error.hidden=true;
   try{
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(this.querySelector('select').value),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
    const result=await response.json();if(!response.ok)throw Error(result.description||copy.error);
    if(typeof window.luxfuemSyncGift==='function')await window.luxfuemSyncGift(result,true);
    if(document.querySelector('cart-items')){location.reload();return;}
    const drawer=document.querySelector('cart-drawer');
    if(drawer&&result.sections?.['cart-drawer'])drawer.renderContents(result);else location.assign(root+'cart');
    pending=null;await refresh();
   }catch(e){error.textContent=e.message||copy.error;error.hidden=false;}
   finally{this.busy=false;button.disabled=false;button.textContent='+ '+copy.add;}
  }
 }
 class RefillProduct extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.select=this.querySelector('[data-rp-scent]');this.qty=this.querySelector('[data-rp-qty]');this.button=this.querySelector('[data-rp-add]');
   this.addEventListener('change',()=>this.update());this.addEventListener('input',()=>this.update());this.button.addEventListener('click',()=>this.add());this.update();
  }
  update(){
   const option=this.select.selectedOptions[0];if(!option)return;
   const total=Number(option.dataset.price)*(Number(this.qty.value)||1);
   this.querySelector('[data-rp-notes]').textContent=option.dataset.notes;
   const label=document.documentElement.lang.startsWith('de')?'Refill in den Warenkorb':'Add refill to cart';
   this.button.textContent=label+' · '+money(total,this.dataset.currency);
   const price=this.closest('product-info')?.querySelector('[data-selected-set-price]');if(price)price.textContent=money(total,this.dataset.currency);
  }
  async add(){
   if(this.busy||!this.qty.reportValidity())return;this.busy=true;this.button.disabled=true;
   const error=this.querySelector('[role=alert]');error.hidden=true;
   try{
    const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(this.select.value),quantity:Number(this.qty.value)}]})});
    const result=await response.json();if(!response.ok)throw Error(result.description||copy.error);
    if(typeof window.luxfuemSyncGift==='function')await window.luxfuemSyncGift(result,true);
    location.assign(this.dataset.root+'cart');
   }catch(e){error.textContent=e.message||copy.error;error.hidden=false;this.busy=false;this.button.disabled=false;}
  }
 }
 if(!customElements.get('lf-refill-product'))customElements.define('lf-refill-product',RefillProduct);
 if(!customElements.get('lf-shipping-progress'))customElements.define('lf-shipping-progress',Shipping);
 if(!customElements.get('lf-refill-offer'))customElements.define('lf-refill-offer',Refill);
 if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>refresh());
 let changing=false;
 document.addEventListener('click',async event=>{
  const cartLink=event.target.closest('#cart-link');
  if(cartLink){
   const drawer=document.querySelector('cart-drawer');
   if(drawer){event.preventDefault();event.stopImmediatePropagation();
    if(typeof drawer.open==='function')drawer.open(cartLink);
    else {drawer.classList.add('active','animate');document.body.classList.add('overflow-hidden');drawer.querySelector('.drawer__close')?.focus();}
    refresh();
   }
   return;
  }
  const close=event.target.closest('.drawer__close,#CartDrawer-Overlay');
  if(close){const drawer=close.closest('cart-drawer');if(drawer){event.preventDefault();event.stopImmediatePropagation();drawer.classList.remove('active');document.body.classList.remove('overflow-hidden');document.getElementById('cart-link')?.focus();}return;}
  const remove=event.target.closest('cart-remove-button');
  if(remove){event.preventDefault();event.stopImmediatePropagation();await change(Number(remove.dataset.index),0);}
 },true);
 async function change(line,quantity){
  if(changing)return;changing=true;
  try{
   const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity})});
   const result=await response.json();if(!response.ok)throw Error(result.description||copy.error);
   if(typeof window.luxfuemSyncGift==='function')await window.luxfuemSyncGift(result,true);
   location.reload();
  }catch(e){const error=document.getElementById('cart-errors')||document.getElementById('CartDrawer-CartErrors');if(error)error.textContent=e.message;changing=false;}
 }
 document.addEventListener('change',event=>{
  if(event.target.matches('cart-items input[name="updates[]"],cart-drawer-items input[name="updates[]"]')){
   event.stopImmediatePropagation();change(Number(event.target.dataset.index),Number(event.target.value));
  }
 },true);
 document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelector('cart-drawer')?.classList.remove('active');document.body.classList.remove('overflow-hidden');}});
 document.addEventListener('shopify:section:load',refresh);
 window.addEventListener('pageshow',refresh);
})();

